<template>
    <div
        class="article"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
        <div class="headcontent">
            <div class="head-wrap">
                <div class="head-left">
                    <img :src="info.pic[0]" class="logo" />
                    <div>
                        <h1>{{info.name}}</h1>
                        <p>{{info.title}}</p>
                    </div>
                </div>
                <div>
                    距离开幕式还剩
                    <span>{{info.day}}</span>天
                </div>
            </div>
        </div>
        <div class="menu">
            <ul>
                <li @click="goHome">首页</li>
                <li @click="clickTo('topcontent')">媒体中心</li>
                <li @click="clickTo('bottomcontent')">会议嘉宾</li>
                <li @click="clickTo('midcontent')">会议议程</li>
                <li @click="goContribute">会议新闻投稿</li>
                <li @click="clickTo('download')">资料下载</li>
            </ul>
        </div>
        <div class="banner-wrap">
            <div class="banner-content">
                <h1>{{info.name}}</h1>
                <!-- <p>{{info.text}}</p> -->
                <h2>{{info.title}}</h2>
                <p class="address">{{info.address}}</p>
            </div>
            <div class="time">
                <p>{{Year}}</p>
                <p>{{Month}}</p>
            </div>
        </div>
        <div class="content">
            <div class="topcontent">
                <div class="media-center">
                    <div class="title">媒体中心</div>
                    <div class="media-wrap">
                        <div class="media-left" @click="goDetail">
                            <img :src="info.banner[0]" />
                            <div class="text-wrap">
                                <p class="name">大会简介</p>
                                <p>{{info.text}}</p>
                            </div>
                        </div>
                        <ul class="media-right">
                            <li
                                v-for="(item, i) in articleList"
                                :key="i"
                                @click="goArticle(item.article_id)"
                            >
                                <img :src="item.img" />
                                <div>
                                    <div class="right-title">{{item.title}}</div>
                                    <p>{{item.description}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="notice-center">
                    <div class="title">通知中心</div>
                    <div class="notice-wrap">
                        <div>
                            <h2>主办方</h2>
                            <p v-for="(item,i) in info.description" :key="i">{{item}}</p>
                            <h2>开幕时间</h2>
                            <p>{{info.time}}</p>
                            <h2>会议地址</h2>
                            <p>{{info.detail}}</p>
                        </div>
                        <div class="qr">
                            <p>
                                微信扫码二维码
                                <br />即可在手机观看
                            </p>
                            <qr-code :text="info.redirect" :size="94" error-level="L"></qr-code>
                        </div>
                    </div>
                </div>
            </div>
            <div class="midcontent" v-if="flowlist.length">
                <p class="meetingcontent">会议议程</p>
                <div class="meeting">
                    <div class="meetingflow" v-for="item in flowlist" :key="item.index">
                        <div class="title">{{item.title | ellipsis(10)}}</div>
                        <p class="text">{{item.content}}</p>
                    </div>
                </div>
            </div>
            <div class="bottomcontent">
                <p class="expert-title">会议嘉宾</p>
                <div class="swiper-father">
                    <swiper :options="swiperOption" class="swiper-container">
                        <swiper-slide
                            v-for="(item, index) in expertlist"
                            :key="index"
                            class="swiper-item"
                        >
                            <img :src="item.avatar" class="avatar" />
                            <div class="shadow" @click="goExpert(item.uid)">
                                <h1>{{item.nickname}}</h1>
                                <p>{{item.describe}}</p>
                            </div>
                            <span>{{item.nickname}}</span>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev" slot="button-prev">
                        <svg class="icon" aria-hidden="true" @click="deletePic(i)">
                            <use xlink:href="#icon-chevronleft" />
                        </svg>
                    </div>
                    <div class="swiper-button-next" slot="button-next">
                        <svg class="icon" aria-hidden="true" @click="deletePic(i)">
                            <use xlink:href="#icon-chevronright" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="download" v-if="info.pdf.length">
                <p class="expert-title">资料下载</p>
                <ul>
                    <li v-for="(item, i) in info.pdf" :key="i">
                        <span></span>
                        <a :href="item.url" :download="item.name">{{item.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    import moment from 'moment';
    export default {
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                loading: true,
                flowlist: '',
                expertlist: [],
                Year: '',
                Month: '',
                showList: [],
                info: {
                    pic: ['']
                },
                isMouse: false,
                articleList: [],
                swiperOption: {
                    // direction : 'vertical',
                    spaceBetween: 20,
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                    slidesPerColumnFill: 'row',
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    hideOnClick: true
                }
            };
        },
        mounted() {
            this.getmeetinginfo();
            this.getexpertlist();
            this.getdetail();
            this.getArticle();
        },
        methods: {
            goHome() {
                this.$router.push({
                    name: 'Welcome'
                });
            },
            goArticle(id) {
                this.$router.push({
                    name: 'article-details',
                    query: {
                        id: id
                    }
                });
            },
            goExpert(id) {
                this.$router.push({
                    name: 'expertcenter',
                    query: {
                        professor: id
                    }
                });
            },
            goDetail() {
                this.$router.push({
                    name: 'cfbb-invite'
                });
            },
            goContribute() {
                this.$router.push({
                    name: 'contribute'
                });
            },
            getmeetinginfo() {
                this.httpGet(this.$root.getmeetinginfo)
                    .then(result => {
                        this.flowlist = result.list;
                        console.log(result);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            clickTo(dom) {
                var box = document.querySelector('.' + dom);
                //   console.log(box.offsetTop);
                window.scrollTo({
                    top: box.offsetTop,
                    behavior: 'smooth'
                });
            },
            getArticle() {
                this.httpGet(this.$root.cfbbList)
                    .then(result => {
                        this.articleList = result.data.slice(0, 3);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            getexpertlist() {
                this.httpGet(this.$root.getexpertlist)
                    .then(result => {
                        this.expertlist = result.list;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            getdetail() {
                this.httpGet(this.$root.cfbbDetail)
                    .then(res => {
                        this.info = res;
                        this.info.day = res.day > 0 ? parseInt(res.day) : 0;
                        this.Year = moment(res.time).format('YYYY');
                        this.Month = moment(res.time).format('MM/DD');
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loading = false;
                    });
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .icon {
        fill: white;
        width: 15px;
        height: 15px;
    }

    .headcontent {
        height: 180px;
        width: 100%;
        background: url('../../assets/img/cfbbtop.png') no-repeat;
        background-size: cover;
        flex-center();

        .head-wrap {
            width: 1180px;
            height: 180px;
            flex-x();

            span {
                color: rgba(24, 65, 255, 1);
                font-weight: bold;
                font-size: 64px;
                margin: 0 10px;
            }

            .head-left {
                flex-x(flex-start);

                img {
                    width: 86px;
                    margin-right: 10px;
                }

                h1 {
                    color: rgba(0, 0, 0, 0.85);
                    font-size: 40px;
                }

                p {
                    color: rgba(0, 0, 0, 0.85);
                    font-size: 16px;
                    width: 236px;
                }
            }
        }
    }

    .menu {
        width: 100%;
        flex-center();
        background: rgba(41, 41, 41, 1);
        height: 54px;
        color: white;

        ul {
            flex-x(flex-start);
            width: 1180px;

            li {
                font-size: 16px;
                width: 148px;
                flex-center();
                cursor: pointer;
            }
        }
    }

    .banner-wrap {
        width: 100%;
        height: 400px;
        background: url('../../assets/img/cfbbmid.png') no-repeat;
        background-size: cover;
        flex-center();
        position: relative;

        .banner-content {
            width: 1180px;
            height: 400px;
            flex-y(flex-start, flex-start);
            color: white;
            padding-left: 200px;

            h1 {
                font-size: 54px;
                margin-top: 70px;
            }

            h2 {
                font-size: 36px;
                margin: 20px 0 10px 0;
            }

            p {
                color: white;
                font-size: 18px;
                width: 400px;

                &.address {
                    font-size: 20px;
                }
            }
        }

        .time {
            position: absolute;
            top: 118px;
            left: 1245px;

            p {
                font-size: 24px;
                color: white;
            }
        }
    }

    .content {
        width: 100%;
        background: url('../../assets/img/cfbbbottom.png') no-repeat;
        background-size: cover;
        flex-y();
    }

    .topcontent {
        width: 1180px;
        padding: 50px 0;
        flex-x();

        .media-center {
            width: 880px;

            .media-wrap {
                flex-x();

                .media-right {
                    width: 480px;
                    flex-y(flex-start, baseline);
                    height: 420px;

                    .right-title {
                        font-weight: bold;
                        margin-bottom: 10px;
                        multi(2);
                        max-width: 324px;
                        max-height: 36px;
                        line-height: 18px;
                        overflow-y: hidden;
                    }

                    li {
                        width: 100%;
                        height: 130px;
                        background: white;
                        border-radius(8px);
                        flex-x(flex-start, flex-start);
                        margin-bottom: 16px;
                        padding: 16px 24px;
                        box-sizing: border-box;
                        cursor: pointer;

                        img {
                            width: 98px;
                            height: 98px;
                            border-radius: 4px;
                            flex-shrink: 0;
                            margin-right: 10px;
                        }

                        p {
                            multi(3);
                            max-width: 324px;
                            max-height: 63px;
                            overflow-y: hidden;
                        }
                    }
                }

                .media-left {
                    width: 380px;
                    height: 420px;
                    background: white;
                    flex-y(flex-start, flex-start);
                    border-radius(8px);
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 214px;
                    }

                    .text-wrap {
                        width: 100%;
                        padding: 24px;
                        box-sizing: border-box;

                        .name {
                            font-size: 16px;
                            margin-bottom: 12px;
                            font-weight: bold;
                            color: black;
                        }

                        p {
                            font-size: 14px;
                            color: black;
                        }
                    }
                }
            }

            .media-wrap:hover {
                cursor: pointer;
            }
        }

        .notice-center {
            .notice-wrap {
                width: 280px;
                height: 420px;
                background: white;
                border-radius(8px);
                overflow: hidden;
                padding: 10px 24px 24px;
                box-sizing: border-box;
                flex-y(space-between, flex-start);

                h2 {
                    font-size: 16px;
                    color: gray3;
                    font-weight: bold;
                    margin-top: 16px;
                }

                p {
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    margin-top: 8px;
                }

                .qr {
                    width: 100%;
                    flex-x(space-between, flex-start);

                    p {
                        color: rgba(0, 0, 0, 0.45);
                    }

                    img {
                        width: 94px;
                        height: 94px;
                    }
                }
            }
        }

        .title {
            font-size: 32px;
            color: rgba(0, 0, 0, 0.85);
            position: relative;
            padding-left: 12px;
            font-weight: bold;
            margin-bottom: 27px;

            &::before {
                content: '';
                position: absolute;
                top: 2px;
                left: 0;
                width: 4px;
                height: 28px;
                background: #152A8C;
            }
        }
    }

    .midcontent {
        display: flex;
        flex-direction: column;
        align-items: center;

        .meetingcontent {
            font-size: 32px;
        }

        .meeting {
            width: 1180px;
            margin-top: 40px;
            padding-top: 91px;
            border-top-left-radius: 100px;
            border-top-right-radius: 0px;
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 92px;
            background: rgba(255, 255, 255, 0.8);

            .meetingflow {
                display: flex;
                flex-direction: row;
                margin-bottom: 54px;
                margin-left: 62px;

                .title {
                    width: 260px;
                    height: 64px;
                    border-radius: 37px;
                    background-color: #647DFA;
                    line-height: 64px;
                    text-align: center;
                    font-size: 24px;
                    color: white;
                    padding: 0 15px;
                    ellipsis();
                }

                .text {
                    font-size: 14px;
                    // margin-left: 20px;
                    padding: 0 20px;
                    width: calc(100% - 300px);
                }
            }
        }
    }

    .bottomcontent {
        flex-y(flex-start, flex-start);
        width: 1180px;
        overflow: wrap;
        margin-top: 50px;

        .swiper-father {
            position: relative;
            height: 856px;
            width: 1180px;

            .swiper-button-prev {
                width: 48px;
                height: 48px;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                flex-center();
                left: -60px;
                top: 300px;
            }

            .swiper-button-next {
                width: 48px;
                height: 48px;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                flex-center();
                left: 1200px;
                top: 300px;
            }
        }

        .swiper-container {
            height: 856px;
            width: 1180px;
            position: relative;

            .swiper-item {
                width: 380px;
                height: 418px;
                border-radius(8px);
                overflow: hidden;
                position: relative;

                .shadow {
                    opacity: 0;
                    cursor: pointer;
                    transition: all 0.3s;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: rgba(0, 0, 0, 0.45);
                    flex-y(flex-start, flex-start);
                    padding: 40px 24px;
                    box-sizing: border-box;

                    h1 {
                        font-size: 30px;
                        color: rgba(255, 255, 255, 1);
                    }

                    p {
                        font-size: 14px;
                        color: rgba(255, 255, 255, 1);
                        margin-top: 16px;
                    }
                }

                span {
                    opacity: 1;
                    transition: all 0.3s;
                    width: 100%;
                    height: 60px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: rgba(0, 0, 0, 0.45);
                    flex-center();
                    color: rgba(255, 255, 255, 0.85);
                }
            }
        }

        .avatar {
            width: 380px;
            height: 418px;
        }

        .swiper-item:hover .shadow {
            opacity: 1;
        }

        .swiper-item:hover span {
            opacity: 0;
        }
    }

    .download {
        width: 1180px;
        flex-y(flex-start, flex-start);
        margin-top: 50px;

        ul {
            background: rgba(255, 255, 255, 0.85);
            padding: 20px;
            width: 1180px;
            border-radius: 8px;
            overflow: hidden;
        }

        li {
            flex-x(flex-start);
            margin-bottom: 15px;

            span {
                width: 4px;
                height: 4px;
                background: #647dfa;
                margin-right: 10px;
            }

            a {
                color: #647dfa;
            }
        }
    }

    .expert-title {
        font-size: 32px;
        color: rgba(0, 0, 0, 0.85);
        position: relative;
        padding-left: 12px;
        font-weight: bold;
        margin-bottom: 27px;

        &::before {
            content: '';
            position: absolute;
            top: 12px;
            left: 0;
            width: 4px;
            height: 28px;
            background: #152A8C;
        }
    }
</style>
